export default "__VITE_ASSET__58b09741__"